export default __webpack_public_path__ + "static/media/logo2.4d8ecaf4.png";